import React from 'react'

const Twitter = () => (
  <svg viewBox="0 0 250 250" xmlns="http://www.w3.org/2000/svg">
    <title>Twitter</title>
    <path
      d="M224.5,80.7 C224.5,78.5 224.5,76.3 224.4,74.1 C234.4,66.9 243.1,57.8 250,47.5 C240.8,51.6 230.9,54.3 220.5,55.6 C231.1,49.3 239.2,39.2 243.1,27.2 C233.2,33.1 222.2,37.3 210.5,39.6 C201.1,29.6 187.8,23.4 173.1,23.4 C144.8,23.4 121.8,46.4 121.8,74.7 C121.8,78.7 122.3,82.6 123.1,86.4 C80.5,84.3 42.7,63.8 17.4,32.8 C13,40.4 10.5,49.2 10.5,58.6 C10.5,76.4 19.6,92.1 33.3,101.3 C24.9,101 17,98.7 10.1,94.9 C10.1,95.1 10.1,95.3 10.1,95.6 C10.1,120.4 27.8,141.2 51.2,145.9 C46.9,147.1 42.4,147.7 37.7,147.7 C34.4,147.7 31.2,147.4 28.1,146.8 C34.6,167.2 53.6,182 76,182.4 C58.4,196.2 36.3,204.4 12.3,204.4 C8.2,204.4 4.1,204.2 0.1,203.7 C22.7,218.1 49.7,226.6 78.6,226.6 C172.9,226.6 224.5,148.4 224.5,80.7 Z"
      fill="url(#logo)"
    />
  </svg>
)

export default Twitter
